import React from "react"
import { keyframes, useTheme } from "@mui/material"

import { AppDataTable } from "../index"
import { mergeDicts } from "@ui-seeker/utils"
import { dsColorNew } from "@palette"


export default function AppCrudTable({ data, columns, ...props }) {
	const { palette } = useTheme()

	return <AppDataTable
		data={data}
		columns={columns}
		toolbarProps={{ actions: false }}
		{...props}
		options={{
			search: true,
			exportExcel: true,
			...props?.options,
			enhancedSetRowProps: (rowData, dataIndex, idx) => mergeDicts({
				sx: {
					backgroundColor: idx % 2 === 0 ? dsColorNew.white : dsColorNew.tableRowAlt,
					borderColor: dsColorNew.grayBorder,
					"&.MuiTableRow-hover:hover": {
						backgroundColor: dsColorNew.hoverBgLight
					},
					"&.mui-row-selected": {
						backgroundColor: dsColorNew.pillActiveBg + ' !important',
						boxShadow: `inset 3px 0 0 ${dsColorNew.appBlue}`,
					},
					"&:has(.is-loading)": {
						animation: `${keyframes({
							"0%": { backgroundColor: palette.primary.light },
							"100%": { backgroundColor: palette.primary.lighter }
						})} 1s linear infinite alternate`
					},
					"&:has(.clicked-details)": {
						backgroundColor: palette.primary.light
					}
				}
			}, props?.options?.enhancedSetRowProps && props?.options?.enhancedSetRowProps())
		}}
	/>
}